var map = {
	"./blog.yml": 152,
	"./cloud.yml": 153,
	"./color.yml": 154,
	"./country.yml": 155,
	"./dio.yml": 156,
	"./doc.yml": 157,
	"./emoji.yml": 158,
	"./git.yml": 159,
	"./icon.yml": 160,
	"./license.yml": 161,
	"./link.yml": 162,
	"./metrics.yml": 163,
	"./people.yml": 164,
	"./soft.yml": 165,
	"./src.yml": 166,
	"./status.yml": 167
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 151;